import { render, staticRenderFns } from "./MaterialCheckboxItem.vue?vue&type=template&id=23cb77f8&scoped=true&"
import script from "./MaterialCheckboxItem.vue?vue&type=script&lang=js&"
export * from "./MaterialCheckboxItem.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCheckboxItem.vue?vue&type=style&index=0&id=23cb77f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cb77f8",
  null
  
)

export default component.exports